import type { WhatsAppInboxMessage } from '@zrsystem/contracts';
import type { ReactElement } from 'react';

import { useWhatsAppInboxMediaObjectUrl } from '@/features/notification/hooks/use-whatsapp-inbox-media-object-url.js';
import { formatWhatsAppInboxTimestamp } from '@/features/notification/lib/whatsapp-inbox-timestamp.js';
import { ChatVoiceNote } from '@/shared/chat/chat-voice-note.js';

export interface WhatsAppInboxAudioBubbleProps {
  readonly message: WhatsAppInboxMessage;
}

function resolveAudioUrl(message: WhatsAppInboxMessage): string | null {
  const mediaUrl = message.media?.url ?? message.mediaUrl;
  if (mediaUrl === null || mediaUrl.length === 0) {
    return null;
  }
  return mediaUrl;
}

export function WhatsAppInboxAudioBubble({ message }: WhatsAppInboxAudioBubbleProps): ReactElement {
  const media = useWhatsAppInboxMediaObjectUrl(
    resolveAudioUrl(message),
    message.media?.mimetype ?? null,
  );

  return (
    <div className="whatsapp-inbox-bubble__media">
      {media.src !== null ? (
        <ChatVoiceNote audioUrl={media.src} messageId={message.id} own={message.fromMe} />
      ) : media.pending ? (
        <ChatVoiceNote audioUrl="" messageId={message.id} own={message.fromMe} pending />
      ) : (
        <p>Áudio indisponível</p>
      )}
      <time className="whatsapp-inbox-bubble__time" dateTime={String(message.timestamp)}>
        {formatWhatsAppInboxTimestamp(message.timestamp)}
      </time>
    </div>
  );
}
